import React, { Component } from 'react';
import { WithStyles, createStyles, Button, Typography, Grid } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { MyPATAudioUpload} from '../../../../common';
import { audioActions } from '../../../reducers/audioCreateContentReducers';

const styles = (theme: Theme) => createStyles({
    orDivider: {
        margin: "25px 0",
        display: "block",
        position: "relative",
        textAlign: "center",
        height: "50px",
        zIndex: 0,
    },
    orText: {
        background: "#E0E6E7",
        height: "40px",
        width: "40px",
        borderRadius: "100%",
        fontStyle: "italic",
        fontSize: 14,
        color: "#989898",
        display: "inline-block",
        paddingTop: "8px",
        position: "absolute",
        top: "-20px",
        left: "50%",
        marginLeft: "-25px",
    },
    dividerBar: {
        position: "absolute",
        left: 0,
        top: "15px",
        width: "100%",
        content: " ",
        height: "1px",
        background: "#E0E6E7",
        zIndex: 1,
    },
    button: {
        margin: theme.spacing.unit,
    },
    addQuestionTitle: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Nunito",
    },
    addAudioBrowse: {
        width: "850px",
        margin: "0 auto",
    },
    warningMsg: {
       display:"flex",
       justifyContent:"center",
       color:'#666666',
       fontWeight: 400,
       fontSize: '12px',
       marginBottom: '18px',
    },
    uploadAudioBox: {
        padding: '20px 12px 10px',
    },
    progressValueText: {
        fontSize: '12px',
    },
});

interface AudioUploadDialogProps extends WithStyles<typeof styles> {
    classes: any;
    onDialogClose: Function;
    audioUrl: string;
    handleURL: Function;
    openAudioUrlModal: Function;
    audioDetails: any;
    uploadAudio: Function;
    mode: string;
}

interface AudioUploadDialogState { }

class AudioUploadDialog extends Component<AudioUploadDialogProps, AudioUploadDialogState> {
    handleVideoUrl = (e: any) => {
        e.preventDefault();
        this.props.handleURL(e.target.value);
    }
    handleSubmitUrl = () => {
        const { openAudioUrlModal } = this.props;
        openAudioUrlModal();
    }
    render() {
        const {
            classes,
            onDialogClose,
            audioUrl,
            uploadAudio,
            mode
        } = this.props;

        return (
            <>
                <MyPATAudioUpload audioUploadHandler={uploadAudio} />
                <span className={classes.warningMsg}>only .mp3 and .wav are supported</span>
            </>
        )


    }
}

const mapStateToProps = (state: any) => {
    return {
        audioUrl: state.audioCreateContent.audioURL,
        audioDetails: state.audioCreateContent.audioDetails,
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    handleURL: audioActions.audioUrlChanged,
    openAudioUrlModal: audioActions.openAudioUrlModal,
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AudioUploadDialog));